module.exports = __webpack_public_path__ + "img/cta-mobile.c2594876.png";